import * as React from 'react';
import {SvgIcon} from '@material-ui/core';

const Visibility = () => {
    return (
        <SvgIcon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.9114 11.3432C20.3362 11.8989 20.3362 12.649 19.9114 13.2038C18.5733 14.9505 15.3631 18.547 11.6151 18.547C7.86717 18.547 4.65693 14.9505 3.31888 13.2038C3.11219 12.9377 3 12.6104 3 12.2735C3 11.9366 3.11219 11.6093 3.31888 11.3432C4.65693 9.59651 7.86717 6 11.6151 6C15.3631 6 18.5733 9.59651 19.9114 11.3432V11.3432Z"
                    stroke="#33415B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.6152 14.9622C13.1001 14.9622 14.3038 13.7584 14.3038 12.2735C14.3038 10.7886 13.1001 9.58487 11.6152 9.58487C10.1303 9.58487 8.92651 10.7886 8.92651 12.2735C8.92651 13.7584 10.1303 14.9622 11.6152 14.9622Z"
                    stroke="#33415B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </SvgIcon>
    );
};

const VisibilityOff = () => {
    return (
        <SvgIcon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.02032 16.7663C5.36682 15.5923 4.05835 14.0651 3.31898 13.1008C3.11223 12.8346 3 12.5072 3 12.1701C3 11.833 3.11223 11.5056 3.31898 11.2394C4.65702 9.49269 7.86723 5.89621 11.6152 5.89621C13.2965 5.89621 14.8684 6.61945 16.2127 7.5757"
                    stroke="#33415B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5241 10.276C13.2752 10.0229 12.9787 9.82169 12.6517 9.68383C12.3246 9.54597 11.9735 9.47423 11.6186 9.47274C11.2637 9.47126 10.912 9.54006 10.5838 9.67517C10.2556 9.81028 9.95743 10.009 9.70643 10.26C9.45544 10.5109 9.25661 10.8091 9.12142 11.1372C8.98623 11.4654 8.91735 11.8171 8.91875 12.172C8.92015 12.5269 8.99181 12.878 9.1296 13.2051C9.26738 13.5322 9.46856 13.8287 9.72153 14.0777M4.44556 19.3393L18.7849 5M9.8228 18.1778C10.4046 18.351 11.0082 18.4403 11.6152 18.4431C15.3631 18.4431 18.5734 14.8466 19.9114 13.0999C20.1181 12.8335 20.2302 12.5058 20.23 12.1686C20.2299 11.8314 20.1175 11.5038 19.9105 11.2376C19.4403 10.6241 18.9358 10.0377 18.3995 9.48103"
                    stroke="#33415B"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </SvgIcon>
    );
};

const RegisterLogo = () => {
    return (
        <svg width="70" height="57" viewBox="0 0 70 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.08 0.00286376C24.9536 0.00095686 24.8269 0 24.7 0C11.0586 0 0 11.0586 0 24.7C0 38.3414 11.0586 49.4 24.7 49.4C24.8269 49.4 24.9536 49.399 25.08 49.3971V0.00286376Z"
                fill="url(#paint0_linear_257_3688)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.082 49.3971V0.00287628C38.5482 0.205969 49.402 11.1855 49.402 24.7C49.402 38.2146 38.5482 49.1941 25.082 49.3971Z"
                fill="#005FEE"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0812 22.04C28.0193 22.04 30.4012 19.6582 30.4012 16.72C30.4012 13.7819 28.0193 11.4 25.0812 11.4C22.143 11.4 19.7612 13.7819 19.7612 16.72C19.7612 19.6582 22.143 22.04 25.0812 22.04ZM25.0812 23.56C19.6246 23.56 15.2012 27.9834 15.2012 33.44V34.2H34.9612V33.44C34.9612 27.9834 30.5377 23.56 25.0812 23.56Z"
                fill="#FDF7F7"
            />
            <g filter="url(#filter0_b_257_3688)">
                <circle cx="49.4006" cy="37.24" r="19.76" fill="url(#paint1_linear_257_3688)" fillOpacity="0.8" />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M49.7788 28.88C49.1492 28.88 48.6388 29.3904 48.6388 30.02V35.72H42.9388C42.3092 35.72 41.7988 36.2304 41.7988 36.86C41.7988 37.4896 42.3092 38 42.9388 38H48.6388V43.7C48.6388 44.3296 49.1492 44.84 49.7788 44.84C50.4084 44.84 50.9188 44.3296 50.9188 43.7V38H56.6188C57.2484 38 57.7588 37.4896 57.7588 36.86C57.7588 36.2304 57.2484 35.72 56.6188 35.72H50.9188V30.02C50.9188 29.3904 50.4084 28.88 49.7788 28.88Z"
                fill="white"
            />
            <defs>
                <filter
                    id="filter0_b_257_3688"
                    x="9.64062"
                    y="-2.52"
                    width="79.5195"
                    height="79.52"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_257_3688" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_257_3688" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_257_3688" x1="0" y1="0" x2="0" y2="49.4" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#27BEFF" />
                    <stop offset="1" stopColor="#0063FF" />
                </linearGradient>
                <linearGradient id="paint1_linear_257_3688" x1="49.4006" y1="17.48" x2="49.4006" y2="57" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0408163" stopColor="#A7DFFF" stopOpacity="0.8" />
                    <stop offset="1" stopColor="#C3E9FF" stopOpacity="0.3" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export {VisibilityOff, Visibility, RegisterLogo};
